module.exports = __webpack_public_path__ + "static/img/01ko.c9c0e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/01ko.jpg
// module id = Y7an
// module chunks = 0